import cx from 'classnames';
import PropTypes from 'prop-types';

import { ButtonText } from 'src/components/ButtonText';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  onCtaClick: PropTypes.func,
  availableFormatsCount: PropTypes.number.isRequired,
  selectedFormatIds: PropTypes.array.isRequired,
};

const defaultProps = {
  className: null,
  onCtaClick: null,
};

export const EmptyFormatsBanner = ({
  className,
  onCtaClick,
  availableFormatsCount,
  selectedFormatIds,
}) => {
  const styles = useStyles();

  const { title, description, cta, onCtaAction } = (() => {
    if (availableFormatsCount !== 0 && selectedFormatIds?.length == 0) {
      return {
        title: 'No formats are selected',
        cta: 'Select formats in settings',
        onCtaAction: onCtaClick,
      };
    } else {
      return {
        title: 'No formats were used when generating this content',
      };
    }
  })();

  return (
    <div className={cx(styles.root, className)}>
      <CustomTypography
        className={styles.title}
        variant={TYPOGRAPHY_VARIANT.medium12}
      >
        {title}
      </CustomTypography>

      {description && (
        <CustomTypography
          className={styles.description}
          variant={TYPOGRAPHY_VARIANT.paragraph12}
        >
          {description}
        </CustomTypography>
      )}

      {cta && onCtaAction && (
        <ButtonText
          className={styles.buttonCta}
          onClick={onCtaAction}
        >
          {cta}
        </ButtonText>
      )}
    </div>
  );
};

EmptyFormatsBanner.propTypes = propTypes;
EmptyFormatsBanner.defaultProps = defaultProps;
